var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-16 b-gray-200 border-radius flex flex-direction-column flex-justify-between",staticStyle:{"height":"9rem"}},[_c('span',{staticClass:"fs-14 color-gray-600"},[_vm._v(_vm._s(_vm.label))]),_c('div',[_vm._t("chart"),_c('div',{staticClass:"color-primary fs-20 fw-500"},[_vm._v(_vm._s(_vm.value))]),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }